module.exports = __webpack_public_path__ + "img/ape_preview.2d0c8358.jpeg";